module.exports = __webpack_public_path__ + "static/img/logo-2.af421cf9.png";